import { Component, Input }                  from '@angular/core';
import { ControlContainer, NgForm, NgModel } from '@angular/forms';

import { CompanyCountryValidationsModel } from '../../../companies/models/company.country-validations';
import { TextControlComponent }           from '../text-control/text-control.component';

@Component({
  selector   : 'wor-postcode-control',
  template: require('./postcode-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class PostcodeControlComponent extends TextControlComponent {
  @Input() maxlength   = 10;
  @Input() validations : CompanyCountryValidationsModel;

  isPostcodeInvalid ( model : NgModel ) : boolean {
    return (
      model.errors?.required
        && model.control.dirty
        && model.control.invalid
    ) || model.control.invalid;
  }
}
